import useSWR from 'swr'
import arcadeApiClient from '../apiClients/arcadeApiClient'

export interface Metric {
  id: number
  name: string
  hasLocationInformation: boolean
  integrationId: number
  isAverage: boolean
  isCalculated: boolean
  isPercentageBased: boolean
  strategicPartnerFundingId: string | null
  strategicPartnerMetricId: string | null
}

const metricFetcher = async (url: string): Promise<Metric[]> =>
  await arcadeApiClient.get(url).then(res => res.data.metrics)

export const useMetrics = () => {
  const { data: metricData, isValidating: isLoadingMetrics } = useSWR(
    'multi_platform/manage/games/valid_metrics',
    metricFetcher,
  )

  return { metricData, isLoadingMetrics }
}
